import { render, staticRenderFns } from "./taskManagement.vue?vue&type=template&id=48f20641&scoped=true"
import script from "./taskManagement.vue?vue&type=script&lang=js"
export * from "./taskManagement.vue?vue&type=script&lang=js"
import style0 from "./taskManagement.vue?vue&type=style&index=0&id=48f20641&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f20641",
  null
  
)

export default component.exports